export enum Marketplace {
  Unknown = 0,
  eBay = 1,
  Goodwill_Finds = 2,
  Poshmark = 3,
  Shop_Goodwill = 4,
  Thrift_Spotter = 5,
}

export interface MarketplaceOption {
  value: Marketplace;
  label: string;
}

export const MARKETPLACE_OPTIONS: MarketplaceOption[] = [
  { value: Marketplace.Unknown, label: 'Unknown' },
  { value: Marketplace.eBay, label: 'eBay' },
  { value: Marketplace.Goodwill_Finds, label: 'Goodwill Finds' },
  { value: Marketplace.Poshmark, label: 'Poshmark' },
  { value: Marketplace.Shop_Goodwill, label: 'Shop Goodwill' },
  { value: Marketplace.Thrift_Spotter, label: 'Thrift Spotter' },
];
